<template>
	<div class="data-content">
		<div class="top-box">
			<div>
				<button v-if="perms.includes('home:repair:normalRepair:extended:add')" class="add-btn" @click="handleAddEdit('add')">新增</button>
				<button class="import-btn" @click="handleImport" v-if="perms.includes('home:repair:normalRepair:extended:import')">导入</button>
				<input style="display: none" ref="uploadExcel" type="file" id="uploadExcel" @change="uploadHandle($event)" />
				<button class="template-btn" @click="handleTemplate" v-if="perms.includes('home:repair:normalRepair:extended:import')">模板下载</button>
			</div>
			<div class="top-right-box">
				<label class="label">关键字</label>
				<el-input class="search-input" size="small" type="text" v-model="searchKey" placeholder="请输入关键字"></el-input>
				<img class="search-btn" src="@/assets/images/sousuo.png" alt="" @click="getDataList" />
				<el-button icon="el-icon-refresh-right" class="refresh-btn" @click="handleReset"></el-button>
			</div>
		</div>
		<div class="data-list-box">
			<el-table
				:data="dataList"
				:row-class-name="tableRowClassName"
				:header-cell-style="{ color: '#444' }"
				class="scroll-table"
				border
				style="width: 100%; height: 100%">
				<el-table-column label="NO." width="60">
					<template slot-scope="scope">
						<span class="no">{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column width="120" prop="warrantyCode" label="延保编号"></el-table-column>
				<el-table-column width="120" prop="purchaseCode" label="购买编号"></el-table-column>
				<el-table-column width="120" prop="regionRtm" label="对应区域RTM"></el-table-column>
				<el-table-column width="100" prop="province" label="省份"></el-table-column>
				<el-table-column width="250" prop="buyerDealer" label="购买经销商名"></el-table-column>
				<el-table-column width="250" prop="serviceDealer" label="服务经销商名"></el-table-column>
				<el-table-column width="250" prop="customerName" label="客户名称"></el-table-column>
				<el-table-column width="120" prop="model" label="机型"></el-table-column>
				<el-table-column width="120" prop="machineId" label="机号"></el-table-column>
				<el-table-column width="105" prop="warrantyStartDate" label="保修起始日期"></el-table-column>
				<el-table-column width="105" prop="firstServiceEndDate" label="首保截至日期"></el-table-column>
				<el-table-column width="105" prop="warrantyEndDate" label="延保截至日期"></el-table-column>
				<el-table-column width="80" prop="warrantyYears" label="延保年限"></el-table-column>
				<el-table-column width="105" prop="warrantyExpiryCount" label="延保到期张数"></el-table-column>
				<el-table-column width="105" prop="warrantyCustomerType" label="延保客户类型"></el-table-column>
				<el-table-column width="105" prop="warrantySalesMethod" label="延保销售方式"></el-table-column>
				<el-table-column width="105" prop="warrantyExpanded" label="索赔增扩零件"></el-table-column>
				<el-table-column fixed="right" label="操作" width="130">
					<template slot-scope="scope">
						<button class="btn-blue" @click="handleAddEdit('view', scope.row)">查看</button>
						<button v-if="perms.includes('home:repair:normalRepair:extended:update')" class="btn-blue" @click="handleAddEdit('edit', scope.row)">
							编辑
						</button>
						<button v-if="perms.includes('home:repair:normalRepair:extended:del')" class="btn-red" @click="handleDelete(scope.row)">删除</button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-wrapper pa25">
				<Pagination
					:page.sync="pageNo"
					:pageSize.sync="pageSize"
					:total="total"
					@sizeChange="handleSizeChange"
					@currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
		<addEdit ref="addEdit" @refresh="getDataList"></addEdit>
		<el-dialog
			:visible.sync="errVisible"
			:show-close="false"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			class="role-dialog"
			width="450px">
			<span slot="title" class="dialog-title">
				<span>提示</span>
				<img src="@/assets/images/close.png" alt="" @click="errVisible = false" />
			</span>
			<ul class="error-list">
				<li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
			</ul>
		</el-dialog>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { repairTypeOptions, serviceTypeOptions, repairAuditStatusOptions } from "@/constant/options";
import addEdit from "@/views/claimantManagement/extendedWarrantyInfo/addEdit.vue";

export default {
	components: {
		addEdit,
		Pagination,
	},
	data() {
		return {
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			// 表格数据
			dataList: [],
			searchKey: "",
			pageNo: 1,
			pageSize: 10,
			total: 0,
			errVisible: false,
			errorList: [],
			repairTypeOptions,
			serviceTypeOptions,
			repairAuditStatusOptions,
		};
	},
	created() {
		this.getDataList();
	},
	methods: {
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		formatTimestamp(ms, datetime) {
			const _fmt = "YYYY-MM-DD";
			return this.$moment(new Date(ms)).format(_fmt);
		},
		handleSizeChange() {
			this.getDataList();
		},
		handleCurrentChange() {
			this.getDataList();
		},
		handleSearch() {
			this.pageNo = 1;
			this.getDataList();
		},
		handleAddEdit(type, data) {
			this.$refs.addEdit.init(type, data);
		},
		handleDelete(data) {
			this.$confirm("确定删除当前延保信息吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request.post(
						"partsWarrantyInfoDel",
						true,
						{
							id: data.id,
						},
						function (r) {
							if (r.code == "0") {
								that.$message.success("删除成功");
								that.getDataList();
							}
						},
					);
				})
				.catch(() => {});
		},
		// 重置查询条件
		handleReset() {
			this.pageNo = 1;
			this.searchKey = "";
			this.getDataList();
		},
		getDataList() {
			let that = this;
			that.$request.post(
				"partsWarrantyInfoList",
				true,
				{
					searchKey: that.searchKey,
					pageNo: that.pageNo,
					pageSize: that.pageSize,
				},
				function (r) {
					if (r.code == "0") {
						that.dataList = r.data.list;
						that.total = r.data.totalCount;
					} else {
						that.$message.error(r.msg);
					}
				},
				function () {},
			);
		},
		// 导入
		handleImport() {
			let el = document.getElementById("uploadExcel");
			el.click();
		},
		// 上传
		uploadHandle(e) {
			let file = e.target.files[0];
			if (file) {
				if (file.name.includes(".xlsx")) {
					let formdata = new FormData();
					formdata.append("file", file);
					let that = this;
					that.$request.initUploadExcel(formdata, "partsWarrantyInfoImport", true).then((data) => {
						if (data.code == 0) {
							that.pageNo = 1;
							that.getDataList();
							if (data.data.length > 0) {
								that.visible = true;
								that.errorList = data.data;
							} else {
								that.$message.success("导入成功");
							}
						}
					});
				} else {
					this.$message.error("文件格式不正确");
				}
			} else {
				this.$message.error("请选择上传的文件");
			}
			this.$refs.uploadExcel.value = "";
		},
		// 模板下载
		handleTemplate() {
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = "/static/template/EXTENDED-WARRANTY-DATA.xlsx";
			linkNode.download = "EXTENDED-WARRANTY-DATA.xlsx";
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
		},
	},
};
</script>

<style lang="scss" scoped>
.block {
	display: block;
}

.data-content {
	.top-box {
		// height: 32px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.add-btn {
		display: inline-block;
		width: 66px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: #117ffc;
		border-radius: 4px;
		color: #fff;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}

	.import-btn {
		display: inline-block;
		width: 66px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}

	.template-btn {
		display: inline-block;
		width: 88px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}

	.top-right-box {
		.label {
			font-size: 14px;
			color: #606266;
			margin-right: 5px;
		}

		.search-input {
			width: 138px;
			margin: 0 10px;
		}

		.search-btn {
			width: 32px;
			vertical-align: middle;
			cursor: pointer;
		}

		.refresh-btn {
			width: 32px;
			height: 32px;
			border: none;
			color: #117ffc;
			padding: 0;
			background-color: rgba(17, 127, 252, 0.2);
			font-weight: bold;
			font-size: 22px;
			vertical-align: bottom;
			margin-left: 5px;
		}
	}

	.btn-blue {
		font-size: 12px;
		font-weight: bold;
		color: #1081fd;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}

	.btn-red {
		font-size: 12px;
		font-weight: bold;
		color: #e9515e;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}
}

.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.error-list {
	height: 50vh;
	box-sizing: border-box;
	padding: 20px;
	overflow: auto;

	li {
		list-style: none;
	}
}

.submit-btn {
	width: 100%;
	background-color: #117ffc;
	color: #fff;
}

.role-dialog {
	.inline-form-item {
		display: flex;
		justify-content: space-between;

		.el-form-item {
			width: 100%;

			&:first-of-type {
				padding-right: 10px;
			}

			&:last-of-type {
				padding-left: 10px;
			}

			.el-select,
			.el-checkbox {
				width: 100%;
			}
		}
	}

	/deep/ .el-dialog {
		border-radius: 10px !important;
	}

	/deep/ .el-dialog__body {
		padding: 0 20px !important;
	}

	/deep/ .el-form-item__label {
		padding: 0 !important;
	}

	/deep/ .el-dialog__footer {
		padding: 20px 20px 30px !important;
	}
}
</style>

<style>
.el-table__fixed-right::before {
	background-color: transparent !important;
}

.scroll-table {
	border: 1px solid #dcdfe6;
}

.scroll-table .yellow {
	background-color: rgba(255, 255, 255);
}

.scroll-table .blue {
	background-color: rgba(246, 249, 253);
}
</style>
